import { readHint } from '@pos/shared';

import { PinUnlock } from '@/features/pin-unlock';
import { SavedSaleNotice } from '@/features/sale-checkout';

export function UnlockPage() {
  const hint = readHint();

  return (
    <div className="flex h-full flex-col px-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(1.5rem,env(safe-area-inset-top))] md:h-auto md:rounded-sheet md:border md:border-line-subtle md:bg-surface-base md:p-6 md:shadow-column">
      <div className="mb-4 empty:hidden">
        <SavedSaleNotice userId={hint?.userId} fullName={hint?.fullName} />
      </div>
      <PinUnlock />
    </div>
  );
}
